const reabTypeVeichuleHeader = [
  {
    group: 'Veiculo',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'veic-nome',
        show: true
      },
      {
        name: 'Peso Máximo',
        id: 'veic-peso',
        show: true
      },
      {
        name: 'Custo Fixo',
        id: 'veic-custo',
        show: true
      }
    ]
  }
]
export default reabTypeVeichuleHeader
